import { pricingGroups, analysisApps } from './pricing'
import type { PricingApp } from './pricing'

// Display grouping for the Home catalogue — mirrors the pricing catalog's
// groups (Woods, Beams, Loads). Only live apps (with a launch target) are
// listed, since the section promises "click a tool to open it".

export interface HomeGroup {
  id: string
  i18nKey: string
  icon: string
  apps: PricingApp[]
}

function liveOnly(apps: PricingApp[]): PricingApp[] {
  return apps.filter((a) => a.launch !== undefined)
}

export const homeGroups: HomeGroup[] = pricingGroups
  .map((g) => ({ id: g.id, i18nKey: g.i18nKey, icon: g.icon, apps: liveOnly(g.members) }))
  .filter((g) => g.apps.length > 0)

/** The heavy end of the suite, shown as its own sheet. `labelKey` resolves
 *  directly (a section label, not a cat.* entry with name/pitch). */
export interface AnalysisSection {
  labelKey: string
  icon: string
  apps: PricingApp[]
}

export const analysisSection: AnalysisSection = { labelKey: 'pricing.step.analysis', icon: 'cpu', apps: liveOnly(analysisApps) }
